import React, { useEffect, useState } from "react";
import register from "../assets/register.png";
import { useNavigate, Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { createUserAction, getOTp } from "../redux/actions/userActions";
import Loading from "./Loading";
import HospitalList from "./HospitalList";
import { toast } from "react-toastify";
import QrButton from "./Button/QrButton";

function Register() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const store = useSelector((state) => state);
  const { loading, success, error, data } = store.createUser;

  const [state, setState] = useState({
    file_number: "",
  });

  useEffect(() => {
    if (success) {
      dispatch(getOTp(state.file_number, state.phone_number));
      navigate("/success", { state: data.data?.patient });
    }
    return () => {
      dispatch({ type: 'CREATE_USER_RESET' })
    };
  }, [success]);

  const changeHandler = (e) => {
    const { name, value } = e.target;
    console.log(name, value);
    setState({
      ...state,
      [name]: value,
    });
  };

  const submitHandler = (e) => {
    e.preventDefault();

    if (!state.file_number) {
      toast.error("Please enter your misas/file number");
      return;
    }

    console.log("state", state);
    let res = dispatch(createUserAction(state.file_number));
  };

  const goToQrScreen = () => {
    navigate('/qr-register')
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-green-50 to-emerald-50 flex flex-col justify-center items-center px-4 py-8">
      <div className="w-full max-w-md sm:max-w-lg lg:max-w-xl bg-white rounded-2xl shadow-2xl overflow-hidden">
        
        {/* Header Section with Background Image */}
        <div 
          className="relative h-48 sm:h-56 lg:h-64 bg-cover bg-center bg-no-repeat"
          style={{
            backgroundImage: `url(${register})`,
          }}
        >
          <div className="absolute inset-0 bg-gradient-to-br from-primary100/80 to-emerald-700/80">
            <div className="absolute bottom-6 left-6">
              <h1 className="text-white text-2xl sm:text-3xl lg:text-4xl font-bold">
                Promise
              </h1>
              <p className="text-white/90 text-lg sm:text-xl">
                Medicals
              </p>
            </div>
          </div>
        </div>

        {/* Registration Form Section */}
        <div className="px-6 py-8">
          <div className="mb-6">
            <h2 className="text-xl sm:text-2xl font-bold text-gray-800 mb-2">
              Create Your Account
            </h2>
            <p className="text-gray-600 text-sm sm:text-base">
              Quick and secure registration with QR code scanning
            </p>
          </div>

          {/* Error Message */}
          {error && (
            <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded-lg">
              <p className="text-red-600 text-sm font-medium">
                {error}
              </p>
            </div>
          )}

          {/* QR Registration Section */}
          <div className="text-center space-y-6">
            {/* QR Icon/Illustration */}
            <div className="flex justify-center">
              <div className="w-24 h-24 sm:w-32 sm:h-32 bg-gradient-to-br from-primary100 to-emerald-600 rounded-2xl flex items-center justify-center shadow-lg">
                <svg 
                  className="w-12 h-12 sm:w-16 sm:h-16 text-white" 
                  fill="none" 
                  stroke="currentColor" 
                  viewBox="0 0 24 24"
                >
                  <path 
                    strokeLinecap="round" 
                    strokeLinejoin="round" 
                    strokeWidth={2} 
                    d="M12 4v1m6 11h2m-6 0h-2v4m0-11v3m0 0h.01M12 12h4.01M16 20h4M4 12h4m12 0h.01M5 8h2a1 1 0 001-1V5a1 1 0 00-1-1H5a1 1 0 00-1 1v2a1 1 0 001 1zm12 0h2a1 1 0 001-1V5a1 1 0 00-1-1h-2a1 1 0 00-1 1v2a1 1 0 001 1zM5 20h2a1 1 0 001-1v-2a1 1 0 00-1-1H5a1 1 0 00-1 1v2a1 1 0 001 1z" 
                  />
                </svg>
              </div>
            </div>

            {/* Instructions */}
            <div className="space-y-3">
              <h3 className="text-lg sm:text-xl font-semibold text-gray-800">
                Register with QR Code
              </h3>
              <p className="text-gray-600 text-sm sm:text-base leading-relaxed">
                Scan your patient QR code to quickly register and access your healthcare portal. 
                This ensures secure and accurate account setup.
              </p>
            </div>

            {/* Registration Steps */}
            <div className="bg-gray-50 rounded-xl p-4 space-y-3">
              <h4 className="font-semibold text-gray-800 text-sm">Quick Setup Steps:</h4>
              <div className="space-y-2 text-xs sm:text-sm text-gray-600">
                <div className="flex items-center space-x-2">
                  <div className="w-2 h-2 bg-primary100 rounded-full"></div>
                  <span>Tap the QR button below</span>
                </div>
                <div className="flex items-center space-x-2">
                  <div className="w-2 h-2 bg-primary100 rounded-full"></div>
                  <span>Scan your patient QR code</span>
                </div>
                <div className="flex items-center space-x-2">
                  <div className="w-2 h-2 bg-primary100 rounded-full"></div>
                  <span>Complete verification</span>
                </div>
              </div>
            </div>

            {/* Action Button */}
            <div className="pt-4">
              {loading ? (
                <div className="flex justify-center py-4">
                  <Loading />
                </div>
              ) : (
                <QrButton 
                  onClick={goToQrScreen} 
                  text={'Scan QR Code to Register'} 
                />
              )}
            </div>
          </div>

          <div className='border-t border-gray-200 pt-4'>
            <p className='text-gray-500 text-sm mb-3'>
              Don't have a QR code? Search by phone or email
            </p>
            <button
              onClick={() => navigate('/phone-lookup')}
              className='w-full py-3 px-6 bg-primary100 text-white font-semibold rounded-xl hover:bg-primary100 transition-all duration-200 transform hover:scale-105 active:scale-95 shadow-lg'
            >
              <div className='flex items-center justify-center space-x-2'>
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                </svg>
                <span>Find My Account</span>
              </div>
            </button>
          </div>

          {/* Footer Links */}
          <div className="mt-8 pt-6 border-t border-gray-100 text-center">
            <p className="text-gray-600 text-sm">
              Already have an account?{' '}
              <Link 
                to="/login" 
                className="text-primary100 font-semibold hover:text-emerald-700 transition-colors duration-200"
              >
                Sign In
              </Link>
            </p>
          </div>

          {/* Security Features */}
          <div className="mt-6 flex justify-center items-center space-x-6 text-xs text-gray-500">
            <div className="flex items-center space-x-1">
              <div className="w-2 h-2 bg-green-500 rounded-full"></div>
              <span>Secure</span>
            </div>
            <div className="flex items-center space-x-1">
              <div className="w-2 h-2 bg-blue-500 rounded-full"></div>
              <span>Fast Setup</span>
            </div>
            <div className="flex items-center space-x-1">
              <div className="w-2 h-2 bg-purple-500 rounded-full"></div>
              <span>NDPR Compliant</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Register;
